.head {
  margin: 4px 0 16px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

/* Ссылка набрана моноширинным: в ней важен каждый символ, и разная
   ширина цифр и букв мешает заметить опечатку при сверке. */
.link {
  display: block;
  padding: 12px 14px;
  font-family: var(--mono);
  font-size: 13px;
  line-height: 1.4;
  color: var(--ink-soft);
  word-break: break-all;
  background: var(--surface-sunken);
  border-radius: var(--r-md);
}

.linkOnHero {
  color: var(--hero-fg);
  background: rgb(255 255 255 / 10%);
}

.copyRow {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.note {
  margin: 10px 4px 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--muted);
}

.empty {
  padding: 22px var(--pad);
  font-size: 14px;
  color: var(--muted);
  text-align: center;
}

.money {
  color: var(--ok);
}

.held {
  color: var(--muted);
}

.reversed {
  color: var(--muted);
  text-decoration: line-through;
}

/* Форма вывода */
.form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  font-size: 13px;
  color: var(--muted);
}

.input {
  width: 100%;
  padding: 12px 14px;
  font: inherit;
  font-size: 16px;
  color: var(--ink);
  background: var(--surface-sunken);
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
  outline: none;
}

.input:focus {
  border-color: var(--ink-soft);
}

.mono {
  font-family: var(--mono);
  font-size: 14px;
}

.hint {
  font-size: 12px;
  line-height: 1.4;
  color: var(--muted);
}

.error {
  font-size: 13px;
  color: var(--danger);
  text-align: center;
}

.networks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: -6px;
}

.network {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  font: inherit;
  color: var(--ink);
  text-align: left;
  background: none;
  border: 1px solid var(--card-border);
  border-radius: var(--r-md);
  cursor: pointer;
}

.network span {
  font-size: 12px;
  color: var(--muted);
}

.active {
  background: var(--accent-wash);
  border-color: var(--ink-soft);
}
